import Reveal from './Reveal.jsx';
import Icon from './Icon.jsx';
import { SERVICES } from '../data/site.js';

export default function Services() {
  return (
    <section id="services" className="services">
      <div className="container">
        <Reveal className="section-header">
          <div className="section-label">Our Services</div>
          <h2 className="section-title">Comprehensive Dental Care</h2>
          <p className="section-desc">
            From routine check-ups to advanced treatments, we offer a full range of dental services
            for the whole family.
          </p>
        </Reveal>
        <div className="services-grid">
          {SERVICES.map((s, i) => (
            <Reveal className="service-card" key={s.title} delay={(i % 3) * 70} tabIndex={0}>
              <div className="service-icon" style={{ background: s.bg }}>
                <Icon name={s.icon} size={26} stroke="#D5175F" width={1.8} />
              </div>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
